import {
	ArrowButtons,
	Breakpoints,
	ContainerGutter,
	Gallery,
	GallerySlide,
	Lentils,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { VouchersLentilsWrapper } from '../../../ui/lentils-wrapper';
import { useIsLandscape } from '../../../../hooks/use-is-landscape';
import { VouchersCtr } from './vouchers-ctr';
import { NormalizedVoucher, VoucherTypeEnum } from '@esportal/portal-service';

export interface VouchersCarouselProps {
	normalizedVouchers: NormalizedVoucher[];
	showButton?: boolean;
	setVouchersPopupData: React.Dispatch<React.SetStateAction<NormalizedVoucher | undefined>>;
	setIsVouchersPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const GallerySlideContainer = styled(GallerySlide)`
	padding-bottom: var(--size-dynamic0120);
	padding-top: 10px;
	padding-left: 10px;
	padding-right: 10px;
`;

export const VouchersCarousel: React.FC<VouchersCarouselProps> = ({
	normalizedVouchers,
	showButton = true,
	setVouchersPopupData,
	setIsVouchersPopupVisible,
}) => {
	const isLandscape = useIsLandscape();
	const slidesAt960 = isLandscape ? 3 : 2;

	return (
		<Gallery
			data-testid="bonos-gallery-slider"
			id="bonos-gallery"
			bottomElements={
				<>
					<ArrowButtons buttonPreviousAriaLabel="To previous slide" buttonNextAriaLabel="To next slide" />

					<VouchersLentilsWrapper $count={normalizedVouchers.length} $slidesAt960={slidesAt960}>
						<Lentils />
					</VouchersLentilsWrapper>
				</>
			}
			aria-label="Vouchers gallery"
			slidesPerPage={{
				[Breakpoints.default]: 1,
				[Breakpoints.b560]: normalizedVouchers.length >= 2 ? 2 : normalizedVouchers.length,
				[Breakpoints.b960]: normalizedVouchers.length >= slidesAt960 ? slidesAt960 : normalizedVouchers.length,
				[Breakpoints.b1280]: normalizedVouchers.length >= 3 ? 3 : normalizedVouchers.length,
				[Breakpoints.b2560]: normalizedVouchers.length >= 4 ? 4 : normalizedVouchers.length,
			}}
			fadingEdges="normal"
			gutter={ContainerGutter.dynamic0100}
		>
			{[
				...normalizedVouchers.map((voucher, index) => (
					<GallerySlideContainer key={index} aria-labelledby={`slide${index}-heading`} stretch>
						<VouchersCtr
							voucher={voucher}
							showButton={showButton}
							voucherType={voucher.vin ? VoucherTypeEnum.CAR : VoucherTypeEnum.PERSON}
							setVouchersPopupData={setVouchersPopupData}
							setIsVouchersPopupVisible={setIsVouchersPopupVisible}
						/>
					</GallerySlideContainer>
				)),
			]}
		</Gallery>
	);
};
